// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1OffersSearchMetaRequest,
  TCianApiSiteV1OffersSearchMetaModel,
  IMappers,
  TCianApiSiteV1OffersSearchMetaResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchMetaResponseSchema167 } from '../../../../../../entities/schemas/SearchMetaResponseSchema167';
import type { IErrorResponseSchema166 } from '../../../../../../entities/schemas/ErrorResponseSchema166';

export function createCianApiSiteV1OffersSearchMetaModel(
  parameters: TCianApiSiteV1OffersSearchMetaRequest,
): TCianApiSiteV1OffersSearchMetaModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'POST',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/offers/search/meta/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICianApiSiteV1OffersSearchMetaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCianApiSiteV1OffersSearchMetaRequest;
}

export async function fetchCianApiSiteV1OffersSearchMeta<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1OffersSearchMetaOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1OffersSearchMetaResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1OffersSearchMetaModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1OffersSearchMetaResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchMetaResponseSchema167, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema166, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1OffersSearchMetaResponse>;
}
